"use strict";
/*
* Copyright (c) Trainline Limited, 2017. All rights reserved.
* See LICENSE.txt in the project root for license information.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var createSkeletonElement_1 = require("./createSkeletonElement");
var createSkeletonProvider_1 = require("./createSkeletonProvider");
exports.createSkeletonProvider = createSkeletonProvider_1.createSkeletonProvider;
var createSkeletonElement_2 = require("./createSkeletonElement");
exports.createSkeletonElement = createSkeletonElement_2.createSkeletonElement;
exports.Div = createSkeletonElement_1.createSkeletonElement('div');
exports.Span = createSkeletonElement_1.createSkeletonElement('span');
exports.H1 = createSkeletonElement_1.createSkeletonElement('h1');
exports.H2 = createSkeletonElement_1.createSkeletonElement('h2');
exports.H3 = createSkeletonElement_1.createSkeletonElement('h3');
exports.P = createSkeletonElement_1.createSkeletonElement('p');
exports.Img = createSkeletonElement_1.createSkeletonElement('img');
exports.default = createSkeletonElement_1.createSkeletonElement;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /Users/alexandrer/development/react-skeletor/lib/index.js
// module id = 41
// module chunks = 0